// extracted by mini-css-extract-plugin
module.exports = {"container":"IconCard-module--container--2Do51","card":"IconCard-module--card--VmY5K","image":"IconCard-module--image--2pths"};